import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "toggle"]
  static values = {
    maxHeight: { type: Number, default: 100 },
    expanded: { type: Boolean, default: false }
  }

  connect() {
    // IntersectionObserverで要素が可視になったときにcheckOverflowを実行
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 可視になったら少し待ってからチェック（レイアウト計算完了を待つ）
          requestAnimationFrame(() => {
            this.checkOverflow()
          })
        }
      })
    }, { threshold: 0.1 })

    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  checkOverflow() {
    const content = this.contentTarget
    const scrollHeight = content.scrollHeight
    const maxHeight = this.maxHeightValue

    if (scrollHeight > maxHeight) {
      content.style.maxHeight = `${maxHeight}px`
      content.classList.add("expandable-card--collapsed")
      this.toggleTarget.classList.remove("d-none")
    } else {
      this.toggleTarget.classList.add("d-none")
    }
  }

  toggle() {
    this.expandedValue = !this.expandedValue

    if (this.expandedValue) {
      this.contentTarget.style.maxHeight = "none"
      this.contentTarget.classList.remove("expandable-card--collapsed")
      this.toggleTarget.textContent = "閉じる"
    } else {
      this.contentTarget.style.maxHeight = `${this.maxHeightValue}px`
      this.contentTarget.classList.add("expandable-card--collapsed")
      this.toggleTarget.textContent = "続きを見る"
    }
  }
}
